import React from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { RefreshCw } from 'lucide-react';

const UpdatePrompt = () => {
    const { needRefresh: [needRefresh, setNeedRefresh], updateServiceWorker } = useRegisterSW();

    if (!needRefresh) return null;

    return (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 px-4 py-3 bg-surface-overlay border border-accent/30 rounded-lg shadow-glow-md animate-appear whitespace-nowrap">
            <RefreshCw className="w-4 h-4 text-accent shrink-0" />
            <p className="text-sm text-text-primary">A new version is available.</p>
            <button
                onClick={() => { setNeedRefresh(false); updateServiceWorker(true); }}
                className="text-sm font-medium text-accent hover:text-accent-hover transition-colors cursor-pointer"
            >
                Reload
            </button>
        </div>
    );
};

export default UpdatePrompt;
